/**
 * apps/server/client — « Le mot de passe par défaut doit être changé » : où le faire ?
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * ─── POURQUOI CE PANNEAU EXISTE ──────────────────────────────────────────────
 * Le serveur EXIGE le changement du mot de passe par défaut (protection A4), mais il ne l'offre
 * plus lui-même : le cycle de vie des identifiants a été déplacé dans la console d'administration,
 * qui est la seule surface d'écriture. C'est une bonne décision d'architecture — et un piège
 * d'ergonomie, si on n'en dit rien.
 *
 * Car du point de vue de l'utilisateur, le logiciel exige une action et n'offre aucun moyen de
 * l'accomplir : une impasse. Ce n'est pas un défaut technique (l'écran existe, ailleurs), c'est un
 * défaut d'INFORMATION — et il coûte le même appel téléphonique.
 *
 * Ce panneau ne fait donc qu'une chose : DIRE OÙ ALLER. Il ne duplique pas le formulaire — le
 * dupliquer ici réintroduirait dans le serveur exactement la surface d'écriture qu'on en a sortie.
 *
 * ─── IL RENVOIE VERS UNE PAGE DU SERVEUR, ET RIEN D'AUTRE ────────────────────
 * Deux rédactions précédentes étaient fausses, et il faut le dire pour qu'on ne les réécrive pas :
 *
 *   1. « ouvrez la console centrale » — la console centrale est celle du PRESTATAIRE. Le client n'y
 *      a aucun compte. On l'envoyait frapper à une porte qui ne s'ouvre pas pour lui.
 *   2. « ouvrez admin.exe » — la console d'administration n'est PAS livrée au client. On le
 *      renvoyait vers un programme qu'il n'aura jamais.
 *
 * Un message qui désigne une issue inexistante est pire que pas de message : il donne l'illusion
 * d'une solution et fait perdre le temps de celui qui la cherche. Le lien pointe donc vers une page
 * du serveur lui-même, que le client a forcément sous la main puisqu'il est déjà dessus.
 */

import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Écrans de gestion uniquement — jamais /display ni /distributor, qui sont face au PUBLIC.
 * Liste d'INCLUSION : un futur écran public n'héritera pas de ce bandeau par défaut.
 */
const ECRANS_DE_GESTION = ['/manage', '/counter', '/sound', '/audit', '/config'];

const S = {
  barre: {
    background: 'linear-gradient(90deg,#7C2D12,#B45309)', color: '#fff',
    padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 12,
    flexWrap: 'wrap', fontSize: '.92rem',
  },
};

export default function DefaultPasswordNotice() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  if (!ECRANS_DE_GESTION.some((p) => pathname.startsWith(p))) return null;
  if (!user?.mustChangePassword) return null;

  return (
    <div style={S.barre}>
      <strong>🔑 Le mot de passe par défaut n’a pas encore été changé.</strong>
      <span style={{ opacity: 0.95 }}>
        Tant qu’il n’est pas changé, toute personne ayant accès au réseau peut se connecter en
        administrateur.
      </span>
      <Link
        to="/change-password"
        style={{
          padding: '6px 14px', borderRadius: 6, background: '#fff', color: '#7C2D12',
          fontWeight: 700, textDecoration: 'none', whiteSpace: 'nowrap',
        }}
      >
        Changer maintenant →
      </Link>
    </div>
  );
}
